function SelectMenu(path, menu) {
    return path === menu ? "selected" : "";
}

export default SelectMenu;